import * as z from 'zod/mini'
import { CreateEventParticipationBody, ManagedCustomerList, messageField } from '@seiri/shared/common'
import { nonEmpty } from './form-schema'

/**
 * What the add-participant dialog does with the chosen clients. Only signing up is built; inviting and the waiting list
 * join it as modes when they are (docs/events.md, _Known follow-ups_).
 */
export type AddParticipantMode = 'signUp'

/**
 * "Pridať účastníkov": several clients at once, each its own `POST .../event-participations`, hence the mapper. Notify
 * starts off, as for a manual reservation; the message goes into the confirmation only while notify is on.
 */
export const addParticipantFormModel = z.object({
  mode: z.literal('signUp'),
  customers: z.array(z.custom<ManagedCustomerList>()).check(nonEmpty('validation.clientsRequired')),
  notifyCustomer: z.boolean(),
  message: messageField,
})
export type AddParticipantFormModel = z.infer<typeof addParticipantFormModel>

export const emptyAddParticipantForm = (): AddParticipantFormModel => ({
  mode: 'signUp',
  customers: [],
  notifyCustomer: false,
  message: '',
})

/** One body per chosen client: confirmed straight away, with the message only when notifying and not blank. */
export function toCreateEventParticipationBodies(
  eventId: string,
  { customers, notifyCustomer, message }: AddParticipantFormModel,
): CreateEventParticipationBody[] {
  const text = notifyCustomer ? message.trim() : ''
  return customers.map((customer) => ({
    eventId,
    customerId: customer.id,
    confirmed: true,
    notifyCustomer,
    ...(text && { message: text }),
  }))
}
